interface SectionTitleProps {
  label?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  theme?: 'light' | 'dark';
}

export default function SectionTitle({
  label,
  title,
  subtitle,
  align = 'center',
  theme = 'light',
}: SectionTitleProps) {
  const textColor = theme === 'dark' ? 'text-foreground-100' : 'text-foreground-900';
  const subColor = theme === 'dark' ? 'text-foreground-400' : 'text-foreground-500';

  return (
    <div className={`mb-10 md:mb-14 ${align === 'center' ? 'text-center' : 'text-left'}`}>
      {label && (
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
          {label}
        </span>
      )}
      <h2 className={`font-heading text-2xl md:text-4xl font-bold ${textColor} leading-tight`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-3 text-sm md:text-base ${subColor} max-w-2xl ${align === 'center' ? 'mx-auto' : ''}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}